import { EInternalPackageType, TPayCustomPackageData } from '../../../../../PayPackageMicrofrontend';
import { IRecommendedPackage } from '../../../../types/reducers/recommendedPackages';
import { mapWidgetSource } from './mapWidgetSource';
import { mapCustomService } from './mapCustomService';

export const mapBuyCustomPackageData = (recommendedPackage: IRecommendedPackage): TPayCustomPackageData => {
  const {
    totalAuctionPoints,
    autoProlong,
    categoriesView,
    discountPercent,
    durationInDays,
    packageStartDate,
    marketingPrice,
    polygonIds,
    price,
    regionNames,
    services,
    type,
    publishType,
    categoriesIds,
  } = recommendedPackage;

  return {
    services: services.map(mapCustomService),
    regionNames,
    polygonIds,
    duration: durationInDays,
    activationDate: packageStartDate,
    price,
    marketingPrice,
    cashbackPercent: null,
    auctionPoints: null,
    discountPercent,
    type: publishType,
    isPromotionByAuction: true,
    totalAuctionPoints,
    autoProlong,
    widgetSource: mapWidgetSource(type),
    categoriesView,
    categoriesIds,

    // FIXME: Нужно присылать эти значения с бека
    autoProlongAvailable: true,
    cashback: null,
    internalType: EInternalPackageType.CustomPackage,
    // Используется для определения какой из саксес-скринов нужно показывать
  };
};
